(() => {
  if (window.lbAddBridge) return;

  const isAdd = (u) => {
    try { return /^\/cart\/(add(?:\.js|\.json)?)\b/.test(new URL(u, location.origin).pathname); }
    catch { return false; }
  };

  window.lbAddBridge = ({ event = 'cart:add:success:lb', windowMs = 6000 } = {}) => {
    let lastClick = 0;
    let xhrURL = '';

    const clicked = () => (Date.now() - lastClick) < windowMs;
    const fire = (info) => { if (clicked()) document.dispatchEvent(new CustomEvent(event, { detail: info })); };

    const onClick = (e) => {
      if (e.target.closest('lb-button, .lb-button[role="button"]')) lastClick = Date.now();
    };
    document.addEventListener('click', onClick, true);

    const origFetch = window.fetch;
    window.fetch = (...args) =>
      origFetch(...args).then((res) => (res?.ok && isAdd(res.url) && fire({ url: res.url, status: res.status }), res));

    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      xhrURL = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300 && isAdd(xhrURL)) fire({ url: xhrURL, status: this.status });
      });
      return origSend.apply(this, arguments);
    };

    return () => {
      document.removeEventListener('click', onClick, true);
      window.fetch = origFetch;
      XMLHttpRequest.prototype.open = origOpen;
      XMLHttpRequest.prototype.send = origSend;
    };
  };
})();

window.lbAddBridge({ event: 'cart:add:success:lb', windowMs: 6000 })
document.addEventListener('cart:add:success:lb', (e) => {
  console.log('Cart updated successfully:', e.detail);
  if(e.detail.status === 200){
    setTimeout(() => {
      document.querySelector('cart-drawer')?.show();
    }, 1000);
  }else {
    console.error('Failed to add item to cart. Status code:', e.detail.status);
  }
});
